import { TOGGLE_CHECKED ,SET_RECEIVER_ID} from "./types";

// Action creator to toggle the checked state
export const toggleChecked = () => ({
  type: TOGGLE_CHECKED,
});

// Add other existing action creators here if this file already exists
// Action creator to set receiver_id
export const setReceiverId = (receiverId) => ({
  type: SET_RECEIVER_ID,
  payload: receiverId,
});

